import { combineReducers } from "redux"
import { connectRouter } from "connected-react-router"
import apiData from "./api-data";
import {history} from "../../config/storeRoutes";

const reducers = combineReducers({
    apiData,
    router: connectRouter(history)
})

export default reducers